import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_file = _resolveComponent("q-file")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_q_file, {
      accept: _ctx.accept,
      clearable: !_ctx.disable,
      disable: _ctx.disable,
      loading: _ctx.disable,
      "max-files": _ctx.maxFiles,
      multiple: _ctx.multiple,
      "model-value": _ctx.uploadQueue,
      "onUpdate:modelValue": _ctx.uploadFiles,
      onRejected: _ctx.rejectedFiles,
      borderless: "",
      class: "bg-grey-lighter q-file-element rounded-borders",
      "label-color": "primary",
      ref: "qFilePicker"
    }, null, 8, ["accept", "clearable", "disable", "loading", "max-files", "multiple", "model-value", "onUpdate:modelValue", "onRejected"]), [
      [_vShow, false]
    ]),
    _renderSlot(_ctx.$slots, "file-uploader")
  ], 64))
}